"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCTANav = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Image = require("../../base-components/Image/Image");
var _Link = require("../../base-components/Link/Link");
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _Button = require("../../base-components/Button/Button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProductCTANav = exports.ProductCTANav = function ProductCTANav(_ref) {
  var asset = _ref.asset,
    productTitle = _ref.productTitle,
    links = _ref.links,
    styles = _ref.styles,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productStickyBarContent,
    "data-qe-id": qeId
  }, /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    className: styles.cardImage,
    src: asset.url,
    alt: asset.alt,
    qeId: qeId ? "".concat(qeId, "__image") : undefined
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.cardName,
    "data-qe-id": qeId ? "".concat(qeId, "__card-title") : undefined
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: productTitle
  })), !!links[0] && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.termsAndConditions
  }, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    to: links[0].url,
    title: links[0].hoverText,
    qeId: qeId ? "".concat(qeId, "__terms-link") : undefined
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: links[0].title
  }))), !!links[1] && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.applyNow
  }, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    to: links[1].url,
    onClick: links[1].onClick,
    title: links[1].hoverText,
    qeId: qeId ? "".concat(qeId, "__button") : undefined,
    id: links[1].id ? links[1].id : undefined
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: styles.primaryButton
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: links[1].title
  })))));
};
ProductCTANav.propTypes = {
  asset: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    alt: _propTypes["default"].string
  }).isRequired,
  productTitle: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    url: _propTypes["default"].string,
    title: _propTypes["default"].string,
    hoverText: _propTypes["default"].string
  })).isRequired,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  qeId: _propTypes["default"].string
};
ProductCTANav.defaultProps = {
  asset: {},
  productTitle: '',
  links: [],
  styles: {},
  qeId: undefined
};